import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
  },
  paper: {
    width: '700px',
    height: 'auto',
  },
  topBar: {
    backgroundColor: '#F6F6F6',
    padding: '20px 24px',
  },
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(1),
    fontSize: 20,
    fontWeight: 600,
    lineHeight: '133.4%',
    color: '#000000',
    // textTransform: 'capitalize',
  },
  text: {
    width: '100%',
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(0.5),
    backgroundColor: theme.palette.background.paper,
    fontSize: 15,
    color: 'black',
  },
  input: {
    minWidth: 250,
    flexGrow: 1,
    fontSize: 16,
    color: 'rgb(0 0 0 / 87%)',
    '& .MuiInputBase-input.Mui-disabled': {
      color: 'rgb(0 0 0 / 87%)',
    },
  },
  row: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(2),
    flexBasis: '45%',
    flexWrap: 'wrap',
    backgroundColor: '#F6F6F6',
  },
  rowButton: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexBasis: '31%',
    flexWrap: 'wrap',
  },
  buttonsDiv: {
    display: 'flex',
    justifyContent: 'inherit',
    alignItems: 'center',
    width: '220px',
    marginTop: '7px',
  },
  fullRow: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(2),
    flexBasis: '100%',
    flexWrap: 'wrap',
  },
  block: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '650px',
    // height: '110px',
  },

  flexBox: {
    display: 'flex',
    padding: '24px',
  },
  profileContainer: {
    marginRight: 32,
    width: 192,
  },
  formContainer: {
    flex: 1,
  },
  errorFormControl: {
    width: '100%',
    marginTop: theme.spacing(-0.3),
    marginBottom: theme.spacing(-0.3),
  },
  errorText: {
    color: theme.palette.error.main,
  },
  subTitle: {
    fontSize: 12,
    textTransform: 'uppercase',
    lineHeight: '32px',
    letterSpacing: 1,
  },
  btn: {
    marginBottom: '3px',
    padding: '12px 22px',
    '& .MuiButton-label': {
      textTransform: 'none',
    },
  },
  textField: {
    width: '100%',
    marginRight: theme.spacing(2),
    //borderBottom: '1px solid #E0E0E0',
    //padding: 5,
    color: 'rgb(0 0 0 / 87%)',
  },
  space: {
    marginLeft: theme.spacing(1),
    cursor: 'pointer',
    color: 'red',
  },
  uploadtext: {
    marginTop: '22px',
    fontSize: '16px',
    lineHeight: '19px',
    fontWeight: 400,
    '& span': {
      color: '#5081FF',
      fontWeight: 600,
    },
  },
  uploadIcon: {
    fontSize: '32px',
    color: '#D2D2DF',
  },
  fileInfo: {
    justifyContent: 'center',
    alignItems: 'center',
    padding: '12px 16px',
    cursor: 'pointer',
    display: 'flex',
    width: '100%',
    background: '#F6F6F6',

    fontSize: '16px',
    lineHeight: '19px',
    fontWeight: 400,
  },
  fileInfoEmpty: {
    backgroundColor: 'red',
    height: '50px',
  },
  fileiconbtn: {
    fontSize: 12,
    color: 'rgba(0, 0, 0, 0.87)',
  },
  fileicon: {
    justifyContent: 'end',
    display: 'flex',
  },
  filename: {
    color: '#5081FF',
    width: '80%',
  },
  filesize: {
    color: '#0000008A',
    width: '100px',
  },
  textFileField: {
    borderRadius: '12px',
    textAlign: 'center',
    width: '100%',
    padding: '21px 0 16px 0',
    background: '#F6F6F6',
    cursor: 'pointer',
  },
  csvFile: {
    height: '192px',
    width: '100%',
  },
  fileadjust: {
    backgroundColor: 'none',
    height: '38px',
    width: '130px',
    border: '1px solid blue',
    color: 'blue',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  fileadjustUpload: {
    height: '38px',
    width: 'fit-content',
    color: 'blue',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  nofilename: {
    fontSize: '12px',
    color: 'grey',
  },
  spanOr: {
    marginTop: '10px',
    display: 'flex',
    justifyContent: 'center',
    width: '591px',
    alignItems: 'center',
  },
  ChooseFile: {
    // backgroundColor:"none",
    // border:"1px solid blue",
    // color:"blue"
  },
}));
